module.exports = __webpack_public_path__ + "img/wave.9fa050b5.svg";